import { render } from "./IconWrap.vue?vue&type=template&id=7f23326a&scoped=true"
import script from "./IconWrap.vue?vue&type=script&lang=js"
export * from "./IconWrap.vue?vue&type=script&lang=js"

import "./IconWrap.vue?vue&type=style&index=0&id=7f23326a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f23326a"]])

export default __exports__